import React from "react";

export default ({ children, location }) => <div>{children}</div>;
